exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload{margin-left:30px;margin-top:30px;margin-bottom:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-0cdb623b!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/article/addPicture.vue
// module id = 437
// module chunks = 0